import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import MarkdownContent from 'src/features/product/product-detail/ui/updates-tab/markdown-content/MarkdownContent';

import { Typography } from '../ui';

export default function Banner() {
  const user = useAuthStore((state) => state.user);
  const bannerMessage = user?.banner_message;

  // Don't render the banner if there's no message
  if (!bannerMessage) {
    return null;
  }

  return (
    <div className="text-white bg-primary text-center py-2 px-4">
      <Typography variant="body-2" weight="medium" className="text-white">
        <MarkdownContent
          className="text-white"
          markdownString={bannerMessage}
        />
      </Typography>
    </div>
  );
}
